import React, { useState } from "react";
import { connect } from "react-redux";
import { createLanguage } from "./actions.js";

const NewLanguageForm = ({ onCreatePressed }) =>{

    const [language, setLanguage] = useState({});

    const handlelanguageChange = (e) => {
        setLanguage({ ...language, [e.target.name]: e.target.value });
    }

    return(
    <div className="border rounded bg-light p-3 m-2">
            <input 
                className="form-control form-control-sm mb-2"
                type="text"
                placeholder="Language/Achievement/Language"
                value={language.name}
                onChange={handlelanguageChange}
                name="name"
            />          
        <div className="text-right">
            <button
                className="btn btn-success btn-sm rounded-circle"
                disabled={language.name === ''}
                onClick={() => onCreatePressed(language)}
            >
                Add
            </button>
        </div>
    </div>
    )
}

export default connect(null, { createLanguage })(NewLanguageForm);